var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _rect5, _path7, _path8, _path9, _path10, _path11, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleWithEggInSaltWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 184,
    viewBox: "0 0 170 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 92.0198C12.4876 90.1619 14.8232 89 17.3671 89H152.633C155.177 89 157.512 90.1619 158.703 92.0199L167.529 105.791C169.044 108.154 166.971 111 163.735 111H6.26463C3.02878 111 0.955955 108.154 2.47064 105.791L11.2968 92.0198Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 179.114,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 178.47,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 137.944C1.96533 121.958 14.9238 109 30.9089 109H140.074C156.059 109 169.017 121.958 169.017 137.944V180H1.96533V137.944Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 112.648C0 107.32 4.3195 103 9.64787 103H160.352C165.68 103 170 107.319 170 112.648V178H0V112.648Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 161.104C149.364 166.432 145.045 170.752 139.716 170.752L29.301 170.752C23.9727 170.752 19.6532 166.432 19.6532 161.104L19.6532 110.935L149.364 110.935L149.364 161.104Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10224_30470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 114H22.6011V146.16H146.416V114Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7557 114L34.1786 146.16H72.6149L132.587 114H93.7557Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.079 114L75.986 146.16H80.1777L139.662 114H135.079Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 114H23.8875C23.1771 114 22.6011 114.576 22.6011 115.286V146.544C22.6011 147.254 23.1771 147.83 23.8875 147.83H147.783C148.493 147.83 149.069 147.254 149.069 146.544V115.286C149.069 114.576 148.493 114 147.783 114Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 93.5693,
    width: 34.8025,
    height: 6.43191,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 87.137,
    rx: 62.6445,
    ry: 11.5774,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 85.2075,
    rx: 63.5937,
    ry: 12.2206,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 149.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10224_30470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 148,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 148.884V153.386V175.898H69.3579V168.18H64.8555L69.3579 163.677V153.386H101.517L106.02 148.884Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10224_30470)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 149.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3953 161.976V160.922L79.1958 157.014H76.5574V155.852H80.8706V156.897L78.0702 160.814H80.9427V161.976H76.3953ZM83.7832 162.084C82.3605 162.084 81.6401 161.408 81.6401 160.085V159.166C81.6401 157.86 82.3605 157.167 83.7292 157.167C85.1069 157.167 85.8273 157.878 85.8273 159.184V160.04H82.9728V160.13C82.9728 160.742 83.2159 161.039 83.7922 161.039C84.2425 161.039 84.5036 160.859 84.5306 160.535H85.8003C85.7463 161.552 85.0529 162.084 83.7832 162.084ZM82.9728 159.103H84.5666C84.5666 158.473 84.3325 158.212 83.7742 158.212C83.2069 158.212 82.9728 158.473 82.9728 159.103ZM86.7884 161.976V157.275H87.923L87.977 158.149C88.1571 157.482 88.5263 157.185 89.1746 157.185H89.5258V158.428H89.2737C88.5803 158.428 88.2472 158.689 88.1211 159.346V161.976H86.7884ZM92.1458 162.084C90.723 162.084 90.0117 161.408 90.0117 160.058V159.193C90.0117 157.842 90.723 157.167 92.1458 157.167C93.5685 157.167 94.2799 157.842 94.2799 159.193V160.058C94.2799 161.408 93.5685 162.084 92.1458 162.084ZM92.1458 161.003C92.7131 161.003 92.9472 160.715 92.9472 160.031V159.22C92.9472 158.536 92.7131 158.248 92.1458 158.248C91.5785 158.248 91.3443 158.536 91.3443 159.22V160.031C91.3443 160.715 91.5785 161.003 92.1458 161.003Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 75,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77L48 73L39.5 81.5L42 85.5L49 77Z",
    fill: "#B7B7B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121 77L122 73L130.5 81.5L128 85.5L121 77Z",
    fill: "#B7B7B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48 73H122L121 77H49L48 73Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2392 83.1961C40.1155 82.5773 40.5888 82 41.2198 82H128.78C129.411 82 129.885 82.5773 129.761 83.1961L129.161 86.1961C129.067 86.6635 128.657 87 128.18 87H41.8198C41.3431 87 40.9327 86.6635 40.8392 86.1961L40.2392 83.1961Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4141 72C47.1489 72 46.8945 72.1054 46.707 72.2929L37.707 81.2929C37.077 81.9229 37.5232 83 38.4141 83H131.586C132.477 83 132.923 81.9229 132.293 81.2929L123.293 72.2929C123.105 72.1054 122.851 72 122.586 72H47.4141ZM122 73H47.9999L39.9999 81H130L122 73Z",
    fill: "#A4A4A4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10224_30470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6867 84.6736C100.487 82.7438 108 73.9438 108 68C108 62.0562 100.487 53.2562 86.6867 51.3264C72.8867 49.4737 62 55.572 62 68C62 80.428 72.8867 86.5263 86.6867 84.6736Z",
    fill: "url(#paint0_radial_10224_30470)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.0784,
    cy: 68,
    rx: 10.7368,
    ry: 10.3725,
    transform: "rotate(90 75.0784 68)",
    fill: "url(#paint1_radial_10224_30470)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10224_30470",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85 68) rotate(180) scale(23 17)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10224_30470",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.0784 68) rotate(90) scale(10.3725 10.7368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10224_30470"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6011,
    y: 114,
    width: 123.815,
    height: 32.1596,
    rx: 1.28638,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10224_30470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    fill: "white",
    transform: "translate(62 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleWithEggInSaltWater);
export default __webpack_public_path__ + "static/media/scale_with_egg_in_salt_water.a70fc6eebdf5af15c84a1dd3d2c7d049.svg";
export { ForwardRef as ReactComponent };